import DomainEntity from '@/models/DomainEntity'

export default class StateSupplier extends DomainEntity {
  static get collectionName() {
    return 'statesupplier/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      supplier: null,
    }
  }
}
